(function (window, document, $) {

    $(document).ready(function () {
        // Dropdowns ===================================================================================================
        var $body = $('body');

        // =======================================================================================================
        // Create the option to show all videos even when there are no filters selected
        $('.show-all-videos').on('click', function (e) {
            // ER: only trigger the JS filter if there is a filter on the page
            if(window.ajaxFilter) {
                e.preventDefault();
                window.ajaxFilter.show();
                window.ajaxFilter.fetchPosts();
                $('[data-show-all-videos]').removeClass('active');
                $('.show-all-videos').addClass('active');
                if (window.scrollY > 100) {
                    $('html, body').animate({
                        scrollTop: $('.filter-section').offset().top
                    }, 400);
                }
            }
        });

        if ($('.show-filter-page').length) {
            $('.show-all-videos').trigger('click');
        }
            
        /**
         * New dropdown toggle functionality used for YogaTV filters
         */

        // Get all the dropdown from document
        document.querySelectorAll('.dropdown-filter-toggle').forEach(dropDownFunc); 

        // Dropdown Open and Close function
        function dropDownFunc(dropDown) {

            if(dropDown.classList.contains('click-dropdown') === true){
                dropDown.addEventListener('click', function (e) {
                    e.preventDefault();

                    let dropdownName = this.dataset.filterDropdownToggleName;
            
                    if (this.nextElementSibling.classList.contains('dropdown-active') === true) {
                        moveDropdownMobile(dropdownName);

                        // Close the clicked dropdown
                        this.parentNode.parentNode.classList.remove('disable-slider'); //remove class to enable transform property needed for the slider (see line 54)
                        /*
                        this.parentElement.classList.remove('dropdown-open');
                        this.nextElementSibling.classList.remove('dropdown-active');
                        document.querySelector('.yogatv-filter').classList.remove('dropdown-opened');
                        */
                        if (document.querySelector('.yogatv-overlay')) {
                            document.querySelector('.yogatv-overlay').classList.add('active'); //to add grey overlay on the body
                        }
                        if (document.querySelector('.section-mobile-footer')) {
                            document.querySelector('.section-mobile-footer').classList.add('d-none'); //hide fixed element when dropdown is open on mobile to fix conflict in certain browser versions
                        }

                        // Method to only perform AJAX filtering when fetch is set to true
                        $(this).closest('form').find('[name=confirmed]').val('1').trigger('change');
            
                    } else {
                        // Close the opened dropdown
                        closeDropdown();
            
                        // add the open and active class(Opening the DropDown)
                        this.parentNode.parentNode.classList.add('disable-slider'); //set class to disable transform property needed for the slider so we can use position: fixed for the dropdown
                        //this.parentElement.classList.add('dropdown-open');
                        //this.nextElementSibling.classList.add('dropdown-active');
                        moveDropdownMobile(dropdownName);
                        document.querySelector('.yogatv-filter').classList.add('dropdown-opened'); //to change z-index filter otherwise in conflict with footer nav
                        if (document.querySelector('.yogatv-overlay')) {
                            document.querySelector('.yogatv-overlay').classList.remove('active');
                        }
                        if (document.querySelector('.section-mobile-footer')) {
                            document.querySelector('.section-mobile-footer').classList.remove('d-none');
                        }                        
                    }

                    // Prevent immediate ajax fetching by setting fetch input to false (quickfix)
                    $(this).closest('form').find('[name=confirmed]').val($('.dropdown-menu').is('.dropdown-active') ? '0' : '1');
                });
            }
        };

        // Listen to the doc click
        window.addEventListener('click', function (e) {

            // Close the menu if click happen outside menu
            if (e.target.closest('.dropdown-container') === null) {
                // Close the opened dropdown
                closeDropdown();
            }

            // Close the menu if clicked on show results/clear filters
            if (e.target.closest('.js-filter-button')) {
                // Close the opened dropdown
                closeDropdown();
                changeButtonOrder();
            }
        });

        window.addEventListener("resize", closeDropdown);

        // Close the openend Dropdowns
        function closeDropdown() {

            let dropdownActive = document.querySelector('.dropdown-active');

            if (dropdownActive) {
                let dropdownName = document.querySelector('.dropdown-active').dataset.filterDropdownName;
                moveDropdownMobile(dropdownName);
            }

            // remove the open and active class from other opened Dropdown (Closing the opend DropDown)
            document.querySelectorAll('.dropdown-container').forEach(function (container) { 
                container.classList.remove('dropdown-open')
            });
            
            document.querySelectorAll('.dropdown-menu').forEach(function (menu) { 
                menu.classList.remove('dropdown-active');
            });

            document.querySelectorAll('.yogatv-filter-options').forEach(function (wrapper) { 
                wrapper.classList.remove('disable-slider');
            });

            let filter = document.querySelector('.yogatv-filter');
            let overlay = document.querySelector('.yogatv-overlay');
            let mobileFooter = document.querySelector('.section-mobile-footer');

            if (filter) {
                filter.classList.remove('dropdown-opened');
            }

            if (overlay) {
                overlay.classList.remove('active');
            }
            
            if (mobileFooter) {
                mobileFooter.classList.remove('d-none');
            }
        }


        // because there are issues on certain mobile version with the slider + dropdown menu move the dropdown menu out of the slider on mobile
        function moveDropdownMobile(dropdownName) {
            if (!dropdownName) {
                return false;
            }

            let defaultLocation = document.querySelector('[data-filter-dropdown-name="' + dropdownName + '"]');
            let mobileLocation = document.querySelector('[data-filter-dropdown-mobile-name="' + dropdownName + '"]');

            if (!defaultLocation || !mobileLocation) {
                return false;
            }

            // Ensure no other mobileLocation has 'dropdown-moved'
            document.querySelectorAll('[data-filter-dropdown-mobile-name]').forEach(location => {
                if (location.classList.contains('dropdown-moved')) {
                    location.classList.remove('dropdown-moved', 'dropdown-active', 'dropdown-slide-up');
                }
            });
            
            if (mobileLocation.classList.contains('dropdown-moved')) {

                // set a short timeout for animation to finish
                setTimeout(() => {
                    defaultLocation.append(mobileLocation.querySelector('.dropdown-menu-inner'));
                }, 250);

            } else if (window.innerWidth < 576) {
                mobileLocation.append(defaultLocation.querySelector('.dropdown-menu-inner'));
                mobileLocation.classList.add('dropdown-moved', 'dropdown-active');

                // set a short timeout for animation to finish
                setTimeout(() => {
                    mobileLocation.classList.add('dropdown-slide-up');
                }, 250);
            }
        }

        // Method to only perform AJAX filtering when fetch is set to true
        $body.on('click', '.js-dropdown-confirm', function (e) {
            e.preventDefault();
            $(this).closest('form').find('[name=confirmed]').val('1').trigger('change');
        });

        // Clear filters in current dropdown
        $body.on('click', '.js-clear-dropdown-filters', function (e) {
            e.preventDefault();

            $(this)
                .closest('.js-dropdown') // Get current dropdown
                .find(':checkbox, :radio') // Only radio and checkboxes
                .filter(':checked') // Limit to the onces that are checked
                .prop('checked', false) // Uncheck them
                .first().trigger('change'); // Enforce at least one "change" event for AJAX mechanism
        });

        // Filter - NIEUW ==============================================================================================
        
        var $filters = $('.yogatv-filter'),
            $radios = $filters.find('input[type="radio"]');

        $radios.on('focus', function () {
            $('.yogatv-filter form').find('input[type="search"]:first-of-type').val('');
        });

        $filters.each(function (index, el) {
            var $el = $(el),
                $form = $el.find('form');

            $form.on('change', function (e) {
                var $filterForm = $(this),
                    targetType = e.target.type;

                if (typeof targetType != 'undefined' && targetType != 'search') {
                    $filterForm.find('input[type="search"]:first-of-type').val('');
                }
            });

            $form.on('reset', function (e) {

                // Reset the select input field.
                $('#shop-price option:first-child').attr("selected", "selected");
                $('#filter-shop-search').val('');
                $form.trigger('change').find('.js-remove-filter').trigger('click');
                updateFilterCounter();
            });

            // trigger change when querystring filter is present
            if (window.location.search.indexOf('filter') != -1
                || window.location.search.indexOf('search') != -1) {
                $form.trigger('change');
            }
        });

        // when we hide the filters on /yogatv update the filter counter in case the user removed all the selected filters
        $(document).on('hide.ajax-filter', function(e) {
            updateFilterCounter();
        });

        
        //put selected checkboxes on top of filter dropdown
        var $checkboxContainer = $(".checkbox-options-container");
        $checkboxContainer.each(function (index, el) {
            
            $(el).on("click", ":checkbox", function() {
                //clear searchfield in dropdown after select checkbox to see complete list again
                var searchBox = document.querySelectorAll('.searchbox');
                searchBox.forEach(singleInput => singleInput.value = '');
                
            });
        });

        //remove all counters when reset filter
        $('.js-filter form').on('reset', function () {
            $(".filter__options .counter").text('');
        });

        //smerige oplossing om aantal gekozen filters te tonen
        function updateFilterCounter() {

            let len = $("#dropdown-video-duur input:checked").length;
            if (len > 0) {
                $(".dropdown-video-duur .counter").text(len);
            } else {
                $(".dropdown-video-duur .counter").text('');
            }

            len = $("#dropdown-video-onderwerp input[name='onderwerp[]']:checked").length;
            if (len > 0) {
                $(".dropdown-video-onderwerp .counter").text(len);
            } else {
                $(".dropdown-video-onderwerp .counter").text('');
            }

            len = $("#dropdown-video-duur_categorie input[name='duur_categorie[]']:checked").length;
            if (len > 0) {
                $(".dropdown-video-duur_categorie .counter").text(len);
            } else {
                $(".dropdown-video-duur_categorie .counter").text('');
            }

            len = $("#dropdown-video-docent input[name='docent[]']:checked").length;
            if (len > 0) {
                $(".dropdown-video-docent .counter").text(len);
            } else {
                $(".dropdown-video-docent .counter").text('');
            }

            len = $("#dropdown-video-stijl input[name='stijl[]']:checked").length;
            if (len > 0) {
                $(".dropdown-video-stijl .counter").text(len);
            } else {
                $(".dropdown-video-stijl .counter").text('');
            }

            len = $("#dropdown-video-niveau input[name='niveau[]']:checked").length;
            if (len > 0) {
                $(".dropdown-video-niveau .counter").text(len);
            } else {
                $(".dropdown-video-niveau .counter").text('');
            }

            len = $("#dropdown-video-language input[name='language[]']:checked").length;
            if (len > 0) {
                $(".dropdown-video-language .counter").text(len);
            } else {
                $(".dropdown-video-language .counter").text('');
            }

            len = $("#dropdown-houding-levels input[name='levels[]']:checked").length;
            if (len > 0) {
                $(".dropdown-houding-levels .counter").text(len);
            } else {
                $(".dropdown-houding-levels .counter").text('');
            }

            len = $("#dropdown-houding-houdingen_soorten input[name='houdingen_soorten[]']:checked").length;
            if (len > 0) {
                $(".dropdown-houding-houdingen_soorten .counter").text(len);
            } else {
                $(".dropdown-houding-houdingen_soorten .counter").text('');
            }

            len = $("#dropdown-houding-klachten input[name='klachten[]']:checked").length;
            if (len > 0) {
                $(".dropdown-houding-klachten .counter").text(len);
            } else {
                $(".dropdown-houding-klachten .counter").text('');
            }
        }
        updateFilterCounter();

        //search in dropdown filters
        document.querySelectorAll('.dropdown-menu').forEach(liveSearchFunc);

        function liveSearchFunc(liveSearch) {
            liveSearch.addEventListener('input', function (e) {
                let cards = liveSearch.querySelectorAll('.filter-dropdown-input-group')
                let search_query = liveSearch.querySelector('.searchbox').value;
                for (var i = 0; i < cards.length; i++) {
                    if(cards[i].innerText.toLowerCase().includes(search_query.toLowerCase())) {
                        cards[i].classList.remove("is-hidden");
                    } else {
                        cards[i].classList.add("is-hidden");
                    }
                }
            });
        }

        $(document).on('ajax-filter-items-fetched', function(e) {
            updateFilterCounter();
            changeCheckboxOrder();
            changeButtonOrder();
        });

        //change the order of the active filter buttons after submit
        function changeButtonOrder() {
            document.querySelectorAll('.dropdown-container-default').forEach(function (container) { 
                if(container.querySelector('.counter').innerHTML){
                    container.classList.add('selected-items');
                } else {
                    container.classList.remove('selected-items');
                }
            });
        }

        if ($(".dropdown-container-default").length) {
            changeButtonOrder();
        }


        function changeCheckboxOrder() {
            let $checkboxContainer = $(".checkbox-options-container");

            if ($checkboxContainer.length) {
                $checkboxContainer.each(function (index, el) {
                    let unorderedList = $(el).children();

                    let i = document.createDocumentFragment();
                    let checked = document.createDocumentFragment();
                    let unchecked = document.createDocumentFragment();
                    
                    for (i = 0; i < unorderedList.length; i++) {
                        if (unorderedList[i].getElementsByTagName("input").length && unorderedList[i].getElementsByTagName("input")[0].checked) {
                            checked.appendChild(unorderedList[i]);
                        } else {
                            unchecked.appendChild(unorderedList[i]);
                        }
                    }
                    $(el).append(checked).append(unchecked);
                })
            }
        }

        if ($(".checkbox-options-container").length) {
            changeCheckboxOrder();
        }
    });

}(window, document, jQuery));